import { Component, OnInit, ViewChild, Optional, Injectable, Inject, AfterViewInit } from '@angular/core';
import { EpbtFaSmartTilesService } from '../../services/epbt-fa-smart-tiles.service';
import { EpbtFaSmartviewsGridComponent } from '../../controls/epbt-fa-smartviews-grid/epbt-fa-smartviews-grid.component';
import { FieldAgentClient, Dashboard, DashboardRequestParameters, SmartView } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpDialogService, EpButtonType, EpButtonStyle } from '@epicor/kinetic';
import { BistrackConfig, ErrorStatus, CustomEvents } from 'ep-bt-controls';
import { API_BASE_URL } from 'ep-bt-field-agent-proxy';
import { EpEventService } from '@epicor/kinetic';
import { EpbtFaDashboardService } from '../../services/epbt-fa-dashboard.service';
import { EpbtFaSmartviewsService } from '../../services/epbt-fa-smartviews.service';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-smart-tiles-details',
  templateUrl: './epbt-fa-smart-tiles-details.component.html',
  styleUrls: ['./epbt-fa-smart-tiles-details.component.scss']
})
export class EpbtFaSmartTilesDetailsComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;
  EpButtonType = EpButtonType;

  fileUrl: string;
  currentUser: any;
  baseURL: string;
  isShow = false;
  iFrameheight: number;
  loadingMessage = false;

  private maxRetries = 5;
  private retryInterval = 6000; // millisecond
  // smartTilesTitle: string;

  @ViewChild(EpbtFaSmartviewsGridComponent, { static: false }) epbtFaSmartviewsGridComponent: EpbtFaSmartviewsGridComponent;
  constructor(private config: BistrackConfig, public faSmartTilesService: EpbtFaSmartTilesService,
    private client: FieldAgentClient, public epEvent: EpEventService, public faaSmartviewsService: EpbtFaSmartviewsService, private dashboardService: EpbtFaDashboardService,
    private fieldAgentService: EpbtFieldAgentService, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.baseURL = baseUrl ? baseUrl : '';
    // this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
    //   this.currentUser = webTrackUser;
    // });

    this.epEvent.onEvents([CustomEvents.DashboardIframe]).subscribe(event => {
      this.faSmartTilesService.navigateTo = 'Graph';
      this.processRequestHtmlFile(event.data);
      this.faSmartTilesService.setSmartTilesHeader(event.data); // For set header
    });

    this.epEvent.onEvents([CustomEvents.Smartviews]).subscribe(event => {
      this.faSmartTilesService.navigateTo = 'Grid';
      const smartviewId: number = event.data;
      this.faSmartTilesService.setSmartViewHeader(event.data); // For set header
      this.faaSmartviewsService.selectedDashboardId = event.data; // save dashboardId for details header
      this.refreshSmartViewGrid(smartviewId);
    });

  }

  ngOnInit() {
    // if (this.dashboardService.dashboardId) {
    //   this.faSmartTilesService.navigateTo = "Graph";
    //   this.processRequestHtmlFile(this.dashboardService.dashboardId);
    // }
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.currentUser = webTrackUser;
    });
    // if(this.faaSmartviewsService.isShowChildGrid == true){

    // }
  }

  ngAfterViewInit() {
    console.log(this.faSmartTilesService.smartTileData, 'smart tiles test1');
  }

  processRequestHtmlFile(dashboardID: number) {
    // let dialog = EpDialogService.progress({ message: '', description: ' BisTrack is processing your request...' });
    this.loadingMessage = true;
    let queueId = 0;
    const dashboardRequestParameters = new DashboardRequestParameters();
    dashboardRequestParameters.dashboardID = dashboardID; ///

    if (this.currentUser.customer.webTrackTradingBranchId && this.currentUser.customer.webTrackTradingBranchId > 0) {
      dashboardRequestParameters.branchID = this.currentUser.customer.webTrackTradingBranchId;
    } else {
      if (this.currentUser.customer.homeBranchId && this.currentUser.customer.homeBranchId > 0) {
        dashboardRequestParameters.branchID = this.currentUser.customer.homeBranchId;
      } else {
        dashboardRequestParameters.branchID = 0;
      }
    }
    dashboardRequestParameters.customerID = this.currentUser.customer.customerId;
    dashboardRequestParameters.bisTrackUserID = this.currentUser.bisTrackUserId && this.currentUser.bisTrackUserId > 0 ? this.currentUser.bisTrackUserId : -1;
    dashboardRequestParameters.webTrackUserID = this.currentUser.userId;
    dashboardRequestParameters.webTrackInstanceID = this.currentUser.webTrackInstanceID;
    this.client.getBisTrackSettingsForInstance(this.currentUser.webTrackInstanceID).subscribe(res => {
      dashboardRequestParameters.dashboardRootPath = res.dashboardReportServerFileLocation;

      this.client.requestDashboard(dashboardRequestParameters).subscribe(resData => {
        if (resData) {
          queueId = resData;
          // setTimeout(() => {
          //   this.client.checkReportStatus(queueId).subscribe(resStatus => {
          //     if (resStatus == 'Processed') {
          //       let url: string = this.baseURL + '/api/Dashboards/' + this.config.getTenantId() + '/dashboard.htm?webTrackUserID=' + this.currentUser.userId + '&dashboardID=' + dashboardID;
          //       const anchorTag = document.createElement("a");
          //       anchorTag.target = 'iframe_a';
          //       anchorTag.href = url;
          //       anchorTag.click();
          //       // this.smartTilesTitle = this.faSmartTilesService.smartTilesTitle;
          //       dialog.close();
          //     }
          //     else {
          //       this.faSmartTilesService.navigateTo = '';
          //       //this.fieldAgentService.displayToastMessage("Message", "Dashboard request failed" + '   Your request was submitted but was not processed. If this problem persists, please contact your site administrator', ErrorStatus.Error);
          //       dialog.close();
          //     }
          //   });
          // }, 2700);
          this.requestDashboardWithRetry(queueId, this.maxRetries, this.retryInterval).then((processed) => {
            if (processed) {
              const url: string = this.baseURL + '/api/Dashboards/' + this.config.getTenantId() + '/dashboard.htm?webTrackUserID=' + this.currentUser.userId + '&dashboardID=' + dashboardID;
              const anchorTag = document.createElement('a');
              anchorTag.target = 'iframe_a';
              anchorTag.href = url;
              anchorTag.click();
              // this.smartTilesTitle = this.faSmartTilesService.smartTilesTitle;
              // dialog.close();
              this.loadingMessage = false;
            } else {
              // this.faSmartTilesService.navigateTo = '';
              // this.fieldAgentService.displayToastMessage("Message", "Dashboard request failed" + '   Your request was submitted but was not processed. If this problem persists, please contact your site administrator', ErrorStatus.Error);
              // dialog.close();
              //  this.loadingMessage = false;
            }
          });
        }
      });
    });
  }

  requestDashboardWithRetry(queueId: number, retry: number, interval: number): Promise<boolean> {

    return new Promise(resolve => {
      this.client.checkReportStatus(queueId).subscribe(resStatus => {
        if (resStatus == 'Processed') {
          resolve(true);
        } else {
          // resolve(false);
          retry--;
          if (retry < 1) {
            // resolve(false);
            // doing one more request after 30 sec (5 requests), for 45 sec
            setTimeout(() => {
              this.client.checkReportStatus(queueId).subscribe(resStatus => {
                if (resStatus == 'Processed') {
                  resolve(true);
                } else {
                  resolve(false);
                  this.faSmartTilesService.navigateTo = '';
                  this.loadingMessage = false;
                }
              });
            }, 45000);
          } else {
            setTimeout(() => {

              this.requestDashboardWithRetry(queueId, retry, interval).then((result) => {
                if (result) {
                  resolve(true);
                }
                // else {
                //   resolve(false);
                // }
              });

            }, interval);
          }
        }
      });
    });
  }

  refreshSmartViewGrid(smartviewId: number) {
    this.epbtFaSmartviewsGridComponent.smartViewListdata(smartviewId);
    // this.smartTilesTitle = this.faSmartTilesService.smartTilesTitle;
  }


  toggleDisplay() {
    if (this.faSmartTilesService.isShow) {
      this.isShow = false;
      this.faSmartTilesService.isShow = this.isShow; // using in dashboard-smart-tiles.html
    } else {
      this.isShow = true;
      this.faSmartTilesService.isShow = this.isShow; // using in dashboard-smart-tiles.html
    }
  }

  getStyles() {

    const styles = {
      'width': '100%',
      'height': this.getHeight().toString() + 'px',
      'border': 0
    };
    return styles;
  }

  getStylesForDefaultPage() {
    const styles = {
      'height': 440 + 'px',
      'width': '100%'
    };
    return styles;
  }


  getHeight(): number {
    const bottomPadding = 20;
    const width = parseInt($('body').width());
    if (width > 250 && width < 1023) {
      // mobile and ipad
      // if (!this.faSmartTilesService.isShow) {
      //   return $(window).outerHeight()  - bottomPadding + 20;
      // }
      return $(window).outerHeight() - ($('.smart-tile-body').offset().top + bottomPadding + 10);


    }
    return $(window).outerHeight() - ($('.smart-tile-body').offset().top + bottomPadding + 10);
  }
}
